import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Logo from "../../components/Logo";
import { useLocation } from "react-router-dom";
import LangChanger from "@layout/LangChanger";

const Header = ({ openModal }) => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <main className="position-absolute w-100 top-0 start-0" style={{ zIndex: 10 }}>
  <div className="bg-transparent">
    <div className="container-xl py-4">
      <Row className="align-items-center justify-content-between">
        <Col xs="4" xl="3">
          <Logo isWhite={true} />
        </Col>

        <Col xs="8">
          <div className="d-flex justify-content-end align-items-center gap-4 fw-300"
               style={{ fontSize: "90%" }}>
            <span className="d-none d-md-block">
              <LangChanger location={location} t={t} />
            </span>

            <button
              className="bg-blue text-white py-3 px-5 rounded-3 border border-white lh-1"
              onClick={() => openModal("in")}
            >
              {t('log_in')}
            </button>

            <button
              className="bg-blue text-white bg-opacity-50 py-3 px-5 rounded-3 lh-1"
              onClick={() => openModal("up")}
            >
              {t('register')}
            </button>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</main>
  );
};

export default Header;
